import { useNavigate, useParams } from 'react-router-dom'
import CustomPaper from '../../containers/Paper'
import CustomInput from '../../components/TextInput'
import { useEffect, useState } from 'react'
import CustomButton from '../../components/Button'
import UtilitiesService from '../../services/UtilitiesService'
import { CircularProgress } from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import useLogout from '../../hooks/useLogout'
import { AppRoutes } from '../../helpers/routes'
import CustomIconButton from '../../components/IconButton'
import ClearIcon from '@mui/icons-material/Clear'
import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated'

const ValidateCredential = () => {
    const params = useParams<{ token: string }>()
    const [token, setToken] = useState<string>(params?.token ?? '')
    const [isValid, setIsValid] = useState<boolean>()
    const [loading, setLoading] = useState<boolean>(false)
    const isAuthenticated = useIsAuthenticated()
    const logout = useLogout()
    const navigate = useNavigate()

    useEffect(() => {
        if (isAuthenticated) logout()
    }, [logout, isAuthenticated])

    const submitToken = () => {
        if (token.trim() === '') return
        setLoading(true)
        new UtilitiesService().validateCredential(token).then((response) => {
            if (response.status !== 200) return
            setIsValid(response.data)
            setLoading(false)
        })
    }

    return (
        <div className="w-full h-[calc(100vh-132px)] flex justify-center items-center">
            <CustomPaper className="relative flex flex-col gap-8 w-[98vw] md:w-[60vw] lg:w-[40vw] text-secondary">
                <span className="text-2xl md:text-4xl font-bold mr-10">
                    Validador de credenciales
                </span>
                <div className="flex flex-col gap-4">
                    <span>Ingresá el código de validación presente en la credencial</span>
                    <CustomInput
                        label="Código de validación"
                        onChange={(e) => setToken(e.target.value)}
                        value={token}
                        className="w-[200px] sm:w-[300px]"
                    />
                </div>

                <div className="flex gap-8 items-center">
                    <CustomButton
                        className="w-fit"
                        disabled={token.trim() === ''}
                        onClick={submitToken}
                    >
                        Validar
                    </CustomButton>
                    {loading ? (
                        <CircularProgress
                            size={'small'}
                            className="text-secondary"
                        />
                    ) : (
                        isValid !== undefined &&
                        (isValid ? (
                            <div className="flex gap-2 font-semibold text-primary items-center">
                                <CheckCircleIcon className="text-success" />
                                Credencial válida
                            </div>
                        ) : (
                            <div className="flex gap-2 font-semibold text-primary items-center">
                                <CancelIcon className="text-error" />
                                Credencial inválida
                            </div>
                        ))
                    )}
                </div>
                <div className="absolute right-5 top-5">
                    <CustomIconButton
                        icon={<ClearIcon />}
                        onClick={() => navigate(AppRoutes.login)}
                        title="Volver"
                    />
                </div>
            </CustomPaper>
        </div>
    )
}

export default ValidateCredential
